var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blueSVGs",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_75)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_298_75",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H22V22H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_298_75)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.96727 19.236C8.96727 18.5394 9.53202 17.9747 10.2286 17.9747H11.773C12.1075 17.9747 12.4283 18.1075 12.6649 18.3441C12.9014 18.5807 13.0343 18.9014 13.0343 19.236C13.0343 19.9325 12.4695 20.4973 11.773 20.4973H10.2286C9.53202 20.4973 8.96727 19.9325 8.96727 19.236ZM18.4262 15.9836C18.2155 15.9997 17.9607 16.009 17.7046 15.994C17.5441 16.8078 17.1062 17.5404 16.4656 18.0671C15.8248 18.5937 15.0213 18.8817 14.1919 18.8817H13.7107C13.7535 19.116 13.7535 19.356 13.711 19.5902H14.1919C15.2111 19.5902 16.1971 19.2273 16.973 18.5664C17.7489 17.9055 18.2641 16.9899 18.4262 15.9836ZM18.7865 15.2297C19.4271 15.1218 20.0088 14.7904 20.4281 14.2943C20.8476 13.7982 21.0777 13.1697 21.0777 12.5201V10.8455C21.0777 10.1165 20.7883 9.41762 20.2728 8.90227C19.7575 8.38692 19.0586 8.0974 18.3298 8.09739H18.1469C17.8545 4.40687 14.7668 1.50293 11.0008 1.50293C7.23483 1.50293 4.14712 4.40687 3.85473 8.09739H3.67181C2.94298 8.0974 2.24403 8.38692 1.72868 8.90227C1.21335 9.41762 0.923828 10.1165 0.923828 10.8455V12.5201C0.923828 13.2489 1.21335 13.9478 1.72868 14.4631C2.24403 14.9786 2.94298 15.268 3.67181 15.268H4.48272C4.81903 15.268 5.09167 14.9953 5.09167 14.659V8.67165C5.09167 5.40815 7.73725 2.76255 11.0008 2.76255C14.2643 2.76255 16.9099 5.40815 16.9099 8.67165V14.659C16.9099 14.8965 17.0458 15.1023 17.2441 15.2027C17.79 15.3922 18.6366 15.2551 18.7865 15.2297Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.da0fcf7549aad6d0f876e72a4510938c.svg";
export { ForwardRef as ReactComponent };